/*
import Navigation from '@/components/navigation/Navigation'
import Dashboard from '@/components/Dashboard'

export default [
	{
		path: '/users/:user_uid/dashboard',
		name: 'Dashboard',
		meta: {
			requiredAuth: true
		},
		components: {
			default: Dashboard,
			menu: Navigation
		},
		props: {
			default: true,
			menu: true
		}
	}
]
*/
import AppShell from '@/modules/shell/AppShell'
import Navigation from '@/components/navigation/Navigation'
import Dashboard from '@/components/Dashboard'

export default [
	{
		path: '/:user_uid',
		redirect: {
			name: 'Dashboard'
		},
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				name: 'Dashboard',
				path: 'dashboard',
				components: {
					default: Dashboard,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/dashboard.js